import template from './user-job-edit.html';
import controller from './user-job-edit.controller';
import './user-job-edit.styl';

let userJobEditComponent = {
  restrict: 'E',
  bindings: {
    userId: '<'
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default userJobEditComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-job-edit/user-job-edit.component.js
 **/